<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-card outlined>
          <v-card-title>Add Members</v-card-title>
          <v-card-text>
            <v-list>
              <v-list-item
                v-for="member in filteredMembers"
                :key="member.id"
                @click="selectMember(member)"
              >
                <v-list-item-avatar>
                  <v-img :src="member.image || '/default-user.jpg'" />
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>{{ member.name }}</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-icon v-if="selectedMember === member">mdi-check</v-icon>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </v-card-text>
          <v-card-actions>
            <v-btn color="primary" @click="confirmSelection">Done</v-btn>
            <v-btn color="secondary" @click="closeDialog">Cancel</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  props: ["groupMembers", "allMembers"],
  data() {
    return {
      selectedMember: null,
    };
  },
  computed: {
    filteredMembers() {
      return this.allMembers.filter(
        (member) => !this.groupMembers.includes(member.id)
      );
    },
  },
  methods: {
    selectMember(member) {
      this.selectedMember = member;
    },
    confirmSelection() {
      if (this.selectedMember) {
        this.$emit("member-added", this.selectedMember);
      }
    },
    closeDialog() {
      this.$emit("close");
    },
  },
};
</script>
